/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CBParentOrg { 
    /**
     * Carbon black parent org key
     */
    cb_parent_org_id?: number;
    /**
     * Carbon black parent org key
     */
    cb_parent_org_key?: string;
    /**
     * Carbon black pop id
     */
    cb_pop_id?: string;
    /**
     * Cbc url
     */
    cbc_url?: string;
    /**
     * User who created parent org entity
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Carbon black parent org super admin credentials path to AWS secret manager
     */
    login_credential_path?: string;
    /**
     * Carbon black org name
     */
    org_name?: string;
    /**
     * User who updated parent org entity
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
}

